import store from '@/store';
import http, { api, unwrap } from './http';

export default {
  list: async (params = {}) => unwrap(api.get('/Documents', params)),

  getById: async (id) => unwrap(api.get(`/Documents/${id}`)),

  create: async (payload, config = {}) => unwrap(api.post('/Documents', payload, config)),

  update: async (id, payload) => unwrap(api.put(`/Documents/${id}`, payload)),

  remove: async (id) => unwrap(api.delete(`/Documents/${id}`)),

  upload: async (formData, params = {}, headers = {}) => unwrap(api.post('/Documents/UploadDocument', formData, { params, headers })),

  // Special: returns a blob URL, not JSON. Uses the raw http instance.
  downloadImage: async (id) => {
    const response = await http.get(`${store.state.settings.apiURL}/Documents/${id}`, {
      responseType: 'blob',
    });
    if (response.status === 200) {
      const blob = new Blob([response.data]);
      return URL.createObjectURL(blob);
    }
    throw new Error(`Image loading failed with status ${response.status}`);
  },
};
